module.exports = __webpack_public_path__ + "img/lock.04e63339.webp";